import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentWidgetMerchantProcessingService extends DestroyableComponent {
  public pay$: Observable<boolean>;
  protected _pay = this.register(new EventEmitter<boolean>());

  public constructor() {
    super();
    this.pay$ = this._pay.asObservable();
  }

  public pay() {
    this._pay.next(true);
  }
}
